<template>
    <!-- S : layer-popup -->
      <div class="layer_section-container">
          <div class="layer-content campaign-detail">
              <h2 class="campaign-detail__title">
                  2023년 9월 신규 ABO 프로모션 <br class="mobile">후원 조건 안내
              </h2>
  
              <div class="abo-guide">
                  <div class="abo-guide__block">
                      <h3 class="abo-build__title">1. 기간: 2023년 9월 1일 (금) 오전 9시 ~ <br class="mobile">11월 30일 (목) 오후 11시 50분</h3>
                  </div>
  
                  <div class="abo-guide__block">
                      <h3 class="abo-build__title">
                          2. 대상자: 2023년 9월 1일 부 유자격 플래티늄 이상 리더
                      </h3>
                  </div>
  
                  <div class="abo-guide__block">
                      <h3 class="abo-build__title">
                          3. 혜택: 전국 체인 호텔/리조트 숙박권 증정
                      </h3>
                  </div>
  
                  <div class="abo-guide__block">
                      <h3 class="abo-build__title">
                          4. 달성조건: 
                          <span>① 유자격 PT그룹 내 9월 신규 ABO 프로모션 택을 받은 신규 ABO를 30조 이상 후원</span> <br>
                          <span>② ①번에 해당하는 신규 ABO 중 9월 ~ 11월 (3개월) 동안 장바구니 스마트 오더 7조 이상 유지</span>
                      </h3>
                  </div>
              </div>
              <p>※ ‘신규 ABO 30조’는 20만원 이상 구매 또는 ABC에서 10만원 이상 구매한 신규 ABO를 모두 포함한 금액입니다.</p>
              <p>※ 3개월 장바구니 스마트 오더의 경우에도 ‘코어제품 10만원 이상 구매 시’ 혜택이 증정됩니다.</p>
          </div>
  
          <div class="align-box size-auto">
              <button type="button" class="btn-modal_close" @click="$emit('layer')">확인</button>
          </div>
      </div>
  </template>
  
  <script>
  export default {
    props: ['showing']
  }
  </script>
  
  <style scoped>
  @import '../assest/css/abo.css';
  </style>
  


// WEBPACK FOOTER //
// src/views/sales/dashboard3/component/layerAttainmentBasket.vue